import { ArrowLeftIcon } from 'lucide-react-native';
import * as React from 'react';
import { Platform, ScrollView, View } from 'react-native';

import { ProfileForm, type ProfileFormConfig } from '@/components/profiles/profile-screen';
import { Button } from '@sixam/ui/button';
import { Icon } from '@sixam/ui/icon';
import { Text } from '@sixam/ui/text';
import { BRAND } from '@sixam/config/brand';

type ProfileEditScreenProps = Readonly<{
  error?: string | null;
  form: ProfileFormConfig;
  message?: string | null;
  onBack: () => void;
  subtitle?: string | null;
  title: string;
  topPadding?: number;
}>;

export function ProfileEditScreen({
  error,
  form,
  message,
  onBack,
  subtitle,
  title,
  topPadding = 52,
}: ProfileEditScreenProps) {
  return (
    <ScrollView
      className="flex-1 bg-background"
      contentContainerClassName="pb-28"
      contentInsetAdjustmentBehavior="automatic"
    >
      <View
        className="gap-4 px-4 pb-6 sm:px-6"
        style={{ backgroundColor: BRAND.color.ink, paddingTop: topPadding }}
      >
        {Platform.OS === 'web' ? (
          <Button accessibilityLabel="Back" onPress={onBack} size="icon" variant="outline">
            <Icon as={ArrowLeftIcon} className="size-5 text-white" />
          </Button>
        ) : null}
        <View className="gap-2">
          {Platform.OS === 'web' ? (
            <Text variant="h2" className="text-white">
              {title}
            </Text>
          ) : null}
          {subtitle ? (
            <Text className="text-white/80" numberOfLines={2}>
              {subtitle}
            </Text>
          ) : null}
        </View>
      </View>

      <View className="gap-4 bg-background px-4 pt-4 sm:px-6">
        {message ? <Text variant="muted">{message}</Text> : null}
        {error ? (
          <Text className="text-sm text-destructive" selectable>
            {error}
          </Text>
        ) : null}

        <ProfileForm form={form} />
      </View>
    </ScrollView>
  );
}
